<template>
    <div v-once>

        <!--MV-->
        <section class="hero_sale">
            <div class="pc wrapper pchero">
                <img src="/kr/resume/static/renew2_img/lp/txt_thanks.png" alt="고마워 메~ 덕분에 100만 유저!!"
                    class="pchero_img pchero_img01">
                <img src="/kr/resume/static/renew2_img/lp/txt_100.png" alt="100만명 회원가입 기념 세일" class="pchero_img">
                <p class="date">6/1(목)〜6/30(금)</p>
                <img src="/kr/resume/static/renew2_img/lp/txt_sale.png" alt="염소 택배 반값 세일" class="pchero_img">
                <p class="omakase">번거로운 작업<br>모두 맡겨주세요.</p>
            </div>
            <img src="/kr/resume/static/renew2_img/lp/sale_mv.png" alt="100만명 회원가입 기념 세일 염소택배 반값 세일"
                class="sp sp_sale_mv">
        </section>

        <div class="cv-btn_sale">
            <div class="renew2_flex wrapper cv-btn_saleflex">
                <img src="/kr/resume/static/renew2_img/lp/yagitaku-txt.png" alt="심플하게 스마트폰으로 입력">
                <img src="/kr/resume/static/renew2_img/lp/nedan_sale.png" alt="9900원이5000원">
            </div>
            <a href="https://rirekisho.yagish.jp/quickmail/basic" class="btn"><span class="btn_big">야가택배</span>사용하기</a>
            <p class="btn_txt">※이력서를 기본으로 경력기술서·송장 지원기업의 배송지 정보를 입력하면 야기택배를 이용할 수 있습니다.</p>
        </div>

        <!--面倒なシーン-->
        <section class="sale_second">
            <h2><img src="/kr/resume/static/renew2_img/lp/second_h2.png" alt="저렴한 가격으로 번거로운 작업을 확실하게 대행!"></h2>
            <div class="print_nedan_en">
                <p class="print_nedan">인쇄비 <span class="nedan900">9000</span>원</p>
                <p class="print_nedan_memo">※이력서,업부경력서 송장을<br>편의점프린트로 인쇄한경우</p>
                <div class="print_nedan_img">
                    <img src="/kr/resume/static/renew2_img/lp/print_sale.png" alt="편의점프린트로 인쇄한 경우">
                </div>
            </div>
            <img src="/kr/resume/static/renew2_img/lp/nedan_plus.png" alt="인쇄비와더하다" class="nedan_plus">

            <p class="print_nedan goukei wrapper">封筒代 <span class="nedan900">1000</span>원</p>
            <p class="print_nedan goukei goukei02 wrapper">봉투값 <span class="nedan900">1200</span>원</p>
            <p class="print_nedan goukei goukei03 wrapper">풀칠영역 <span class="nedan900">1000</span>원</p>
            <img src="/kr/resume/static/renew2_img/lp/nedan_equal.png" alt="전부합쳐" class="nedan_equal">
            <p class="goukei sougaku wrapper"><span class="sougaku_ti">총액</span> 약<span
                    class="sougaku_big">12,000</span>원</p>
            <img src="/kr/resume/static/renew2_img/lp/imadake.png" alt="바로지금5000원" class="imadake_img">
            <div class="cv-btn_sale wrapper">
                <a href="https://rirekisho.yagish.jp/quickmail/basic" class="btn"><span class="btn_big">야기택배</span>를
                    이용하기</a>
                <p class="btn_txt">※이력서를 기본으로 경력기술서·송장 지원기업의 배송지 정보를 입력하면 야기택배를 이용할 수 있습니다.</p>
                <p class="btn_txt">※본 행사는 6월 한 달간 야기슈 100만 명 회원가입 기념 기획으로 진행하고 있습니다.7월 부터는 9900원으로 서비스를 이용할 수 있습니다.양해
                    부탁드립니다。</p>
            </div>
        </section>

        <!--使い方-->
        <section class="third">
            <div class="wrapper">
                <h2 class="pc"><img src="/kr/resume/static/renew_img/quickmail/third-h2.png"
                        alt="쓰윽쓰윽! 야기택배에 입력만 해줘 메에~~"></h2>
                <h2 class="sp"><img src="/kr/resume/static/renew_img/quickmail/third-h2-sp.png"
                        alt="쓰윽쓰윽! 야기택배에 입력만 해줘 메에~~"></h2>
                <ul class="step pc">
                    <li>
                        <div class="step-item">
                            <img src="/kr/resume/static/renew_img/quickmail/step01.png" alt="①스마트폰PC에서 간편입력">
                            <p class="step-ti">①스마트폰 PC에서 간편입력</p>
                            <p>※수신처,이력서 필수</p>
                        </div>
                    </li>
                    <li>
                        <div class="step-item">
                            <img src="/kr/resume/static/renew_img/quickmail/step02.png" alt="②구입완료">
                            <p class="step-ti">②구입완료</p>
                            <p>※카드결제만 가능</p>
                        </div>
                    </li>
                    <li>
                        <div class="step-item">
                            <img src="/kr/resume/static/renew_img/quickmail/step03.png" alt="③ヤギの宅配便で郵送">
                            <p class="step-ti">③야기택배 발송</p>
                            <p>※도착까지 1~2일 정도</p>
                        </div>
                    </li>
                </ul>
                <ul class="step-sp sp">
                    <li>
                        <div class="step-item">
                            <img src="/kr/resume/static/renew_img/quickmail/step01-sp.png" alt="①スマホやPCで簡単入力">
                            <p class="step-ti">①스마트폰 PC에서 간편입력</p>
                            <p>※수신처,이력서 필수</p>
                        </div>
                    </li>
                    <li>
                        <div class="step-item">
                            <img src="/kr/resume/static/renew_img/quickmail/step02-sp.png" alt="②購入完了">
                            <p class="step-ti">②구입완료</p>
                            <p>※카드결제만 가능</p>
                        </div>
                    </li>
                    <li>
                        <div class="step-item">
                            <img src="/kr/resume/static/renew_img/quickmail/step03.png" alt="③ヤギの宅配便で郵送">
                            <p class="step-ti">③야기택배 발송</p>
                            <p>※도착까지 1~2일 정도</p>
                        </div>
                    </li>
                </ul>
            </div>
        </section>

        <section class="fourth">
            <div class="wrapper">
                <h3 class="fourth-h3 pc"><img src="/kr/resume/static/renew_img/quickmail/cv-txt.png"
                        alt="인쇄부터 발송까지 귀찮은 일은 하지마세요."></h3>
                <h3 class="fourth-h3 sp"><img src="/kr/resume/static/renew_img/quickmail/cv-txt-sp.png"
                        alt="인쇄부터 발송까지 귀찮은 일은 하지마세요."></h3>
                <div class="hero-txt fourth-hero-txt">
                    <img src="/kr/resume/static/renew_img/quickmail/yagitaku-txt-nomal.png" alt="야기택배"
                        class="txt-nomal-sp">
                    <img src="/kr/resume/static/renew2_img/lp/nedan_sale.png" alt="5,000원（세금포함）"
                        class="fourth-nedan pc">
                    <img src="/kr/resume/static/renew2_img/lp/nedan_sale.png" alt="5,000원（세금포함）"
                        class="sp sp-nedan sp-hero-txt">
                    <!-- <img src="/kr/resume/static/renew_img/quickmail/yagitaku-nedan.png" alt="990원（税込）" class="fourth-nedan pc">
                    <img src="/kr/resume/static/renew_img/quickmail/yagitaku-nedan-sp.png" alt="990원（税込）" class="sp sp-nedan sp-hero-txt"> -->
                </div>
                <div class="hero-txt">
                    <img src="/kr/resume/static/renew_img/quickmail/deco03.png" alt="래디시" class="deco03">
                    <a href="/kr/resume/quickmail/basic" target="_blank" class="cv-link"><img
                            src="/kr/resume/static/renew_img/quickmail/cv-btn02.png" alt="야기에 맡겨줘"
                            class="cv-btn pyon01"></a>
                    <img src="/kr/resume/static/renew_img/quickmail/deco03.png" alt="래디시" class="deco03">
                </div>
            </div>
        </section>

        <section class="fqa wrapper">
            <h3 class="fqa-ti">자주있는 질문</h3>
            <ul class="fqa-container">
                <li class="fqa-list">
                    <h4 class="question">용지 사이즈를 지정할 수 있습니까?</h4>
                    <p class="answer">할 수 없습니다. 용지 사이즈는 A4고정입니다.</p>
                </li>
                <li class="fqa-list">
                    <h4 class="question">Yagish 이외에 작성한 서류를 보낼 수 있을까요?</h4>
                    <p class="answer">할 수 없습니다. Yagish에서 작성된 템플릿만 지원할 수 있습니다.</p>
                </li>
                <li class="fqa-list">
                    <h4 class="question">용지·봉투의 품질에 대해 알려 주세요.</h4>
                    <p class="answer">이력서 용도에 맞는 고품질 용지와 흰색 봉투를 사용하므로 품질에 대한 문제는 없습니다. 또한 지원한 기업이 확인하기 쉽도록 「이력서 재중」의
                        스탬프를 찍어 발송합니다.</p>
                </li>
                <li class="fqa-list">
                    <h4 class="question">개인정보는 어떻게 관리되고 있나요?</h4>
                    <p class="answer">개인정보 관리는 시스템화되어 정보유출 방지대책을 세우고 있습니다. 직접 사람이 확인 하는더블 체크 관리 체제도 유지 하고 있습니다.</p>
                </li>
                <li class="fqa-list">
                    <h4 class="question">언제 발송되나요?</h4>
                    <p class="answer">지원하는 기업의 지역에 따라 배송기간이 다릅니다.영업일 기준으로 1~2일 이내에 발송되므로 급한 경우는 PDF 다운로드 하시거나, 편의점 프린트를
                        하는 등 직접 처리하시기 바랍니다.</p>
                </li>
                <li class="fqa-list">
                    <h4 class="question">발송완료 확인을 할 수 있나요?</h4>
                    <p class="answer">우편발송 상태는 확인할 수 없지만 우체통에 투입 후 시스템에서 "발송완료" 메일을 보내드리오니 확인하시기 바랍니다.</p>
                </li>
                <li class="fqa-list">
                    <h4 class="question">등기우편이나 빠른우편으로 보낼 수 있나요?</h4>
                    <p class="answer">할 수 없습니다. 급하시거나 배송상태를 확인하고 싶으시면 직접 발송 해주시기 바랍니다. </p>
                </li>
                <li class="fqa-list">
                    <h4 class="question">주문 후 취소 가능한가요?</h4>
                    <p class="answer">할 수 없습니다. 주문하고 결제까지 완료되면 원칙적으로 취소가 불가합니다.</p>
                </li>
            </ul>
        </section>

        <section class="fifth">
            <div class="wrapper">
                <div class="print">
                    <img src="/kr/resume/static/renew_img/quickmail/print01.png" alt="편의점 프린트" class="print-sp">
                    <div class="print-txt">
                        <p class="print-ti">면접에 이력서를 가지고 갈<span>때에는<br>
                            </span>편의점 프린트<span>를 써봐요~메에~~</span></p>
                        <!--<img src="/kr/resume/static/renew_img/quickmail/print02.png" alt="面接に履歴書を持っていくときは、コンビニプリントを使うメェ〜">-->
                        <a href="/kr/resume/" target="_blank" class="link link-deco">편의점 프린트 사용</a>
                    </div>
                </div>
            </div>
        </section>

        <section class="sixth">
            <div class="wrapper">
                <div class="hero-txt">
                    <img src="/kr/resume/static/renew_img/quickmail/deco03.png" alt="래디시" class="deco03 deco04">
                    <a href="/kr/resume/quickmail/basic" target="_blank" class="cv-link"><img
                            src="/kr/resume/static/renew_img/quickmail/cv-btn03.png" alt="야기에게 맡겨 메에~~"
                            class="cv-btn pyon01"></a>
                    <img src="/kr/resume/static/renew_img/quickmail/deco03.png" alt="래디시" class="deco03">
                </div>
            </div>
        </section>

        <div style="text-align: center; padding: 20px;">
            <a href="/kr/resume/quickmailterms" target="_blank">이용약관은<span style="color: #E3165C;">이쪽</span></a>
        </div>

    </div>
</template>
<style lang="css" src="@/assets/css/quickmail_stylesheet.css"></style>
<style lang="css" src="@/assets/css/quickmail_animation.css"></style>
<style lang="css" src="@/assets/css/quickmail_reset.css"></style>

<style lang="scss" scoped>
body {
    background: #EFF8F8;
}

.hero-img {
    padding: 0;
}

.hero-img_LP {
    margin: 0 calc(50% - 50vw);
    width: 100vw;
    padding: 20px 50px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}

@media screen and (max-width:480px) {
    .hero-img_LP {
        padding: 20px;
    }
}
</style>


<style lang="scss" scoped>
.hero_sale {
    text-align: center;
    background-image: url(/static/renew2_img/lp/back02.png);
    background-repeat: no-repeat;
    background-size: 100% auto
}

.hero_sale .pchero {
    background: rgba(255, 255, 255, 0.5);
}

.hero_sale .pchero .pchero_img {
    display: inline-block;
    width: 50%;
}

.hero_sale .pchero .pchero_img01 {
    padding: 40px 0 20px;
    width: 30%;
    display: block;
    margin: 0 auto;
}

.hero_sale .date {
    width: 100vw;
    padding: 30px;
    margin-top: -40px;
    margin-bottom: -20px;
    margin-left: calc(-50vw + 50%);
    font-size: 3rem;
    font-weight: bold;
    color: #fff;
    background: #E95B10;
}

.hero_sale .omakase {
    font-size: 2rem;
    font-weight: bold;
    color: #004D40;
    margin-top: 0;
    padding-bottom: 50px;
}

.cv-btn_sale {
    text-align: center;
}

.cv-btn_sale .btn {
    color: #fff;
    background: #E3165C;
    padding: 20px 30px;
    border-radius: 50px;
}

.cv-btn_sale .btn .btn_big {
    font-size: 1.5rem;
}

.cv-btn_sale .btn_txt {
    font-size: 0.8rem;
    margin-top: 30px;
}


.cv-btn_saleflex {
    align-items: center;
}

.sale_second {
    background: #EFF8F8;
    text-align: center;
    padding: 30px 0;
    margin-top: 100px;
}

.sale_second h2 {
    width: 50%;
    margin: 0 auto 20px;
}

.sale_second .print_nedan {
    font-size: 2rem;
    font-weight: bold;
    color: #004D40;
    padding-top: 30px;
}

.sale_second .print_nedan_en {
    background: #C1EEEE;
}

.sale_second .nedan900 {
    font-size: 3rem;
}

.sale_second .print_nedan_memo {
    position: relative;
    top: -35px;
    font-size: 0.8rem;
    z-index: 5;
}

.sale_second .print_nedan_img {
    position: relative;
    margin-top: -100px;
    z-index: 2;
}

.sale_second .print_nedan_img::after {
    position: absolute;
    content: url(/static/renew2_img/lp/syorui_sale.png);
    left: 50%;
    bottom: -200px;
    transform: translateX(-50%);
    display: block;
}

.sale_second .nedan_plus {
    margin-top: 280px;
    width: 50px;
    margin-bottom: 20px;
}

.sale_second .nedan_equal {
    height: 50px;
    width: auto;
}

.sale_second .goukei {
    position: relative;
    background: #fff;
    border: 5px solid #004D40;
    border-radius: 10px;
    padding: 50px 20px;
    margin-bottom: 15px;
}

/*.sale_second .goukei01{
        position: absolute;
        content: url(img/goukei01.svg);
    }*/
/*.sale_second .goukei02{
        position: absolute;
        content: url(img/goukei02.svg);
    }
    .sale_second .goukei03{
        position: absolute;
        content: url(img/goukei03.svg);
    }*/
.sale_second .sougaku {
    background: #FFFFE8;
    font-size: 2rem;
    font-weight: bold;
    color: #004D40;
}

.sale_second .sougaku_big {
    font-size: 3rem;
}

.sale_second .sougaku_ti {
    background: #0F9934;
    color: #fff;
    padding: 15px 10px;
    width: 40px;
    display: inline-block;
    border-radius: 30px;
    font-size: 1rem;
}

@media screen and (max-width: 768px) {
    .hero_sale .sp_sale_mv {
        width: 100%;
    }

    .cv-btn_saleflex img {
        width: 100%;
        margin: 0 auto;
    }

    .sale_second h2 {
        width: 100%;
    }

    .sale_second .print_nedan_img img {
        width: 100%;
    }

    .sale_second .print_nedan_img::after {
        transform: translateX(-50%) scale(0.5);
    }

    .sale_second .print_nedan_memo {
        top: -70px;
    }

    .sale_second .nedan_plus {
        margin-top: 150px;
    }

    .sale_second .goukei {
        margin: 20px;
    }

    .sale_second .sougaku {
        padding: 50px 20px;
    }

    .sale_second .imadake_img {
        width: 80%;
    }
}
</style>

<script>
export default {
    data: function () {
        return {
            question1: false,
            question2: false,
            question3: false,
            question4: false,
            question5: false,
            question6: false,
            question7: false,
            question8: false
        }
    },
    computed: {},
    methods: {
        viewAnswer: function (name) {
            console.error(name)
            this.question1 = true
        }
    },
    watch: {},
    mounted: function () { }
}
</script>